export type EstadoCarregamento = 'inicial' | 'carregando' | 'pronto' | 'erro'

export type TipoUsuario = 'all' | 'group' | 'mine'

export type PerfilAcessoAtivo = 'gestor' | 'pessoal'

export type UsuarioAcesso = {
  id: string | number
  nome: string
  email: string
  tipo: TipoUsuario
  temCpf: boolean
  ehSuporte: boolean
  acessoPorLideranca: boolean
}

export type EmpresaAcesso = {
  id: string | number
  nome: string
  portaria671: boolean
  possuiInternacionalizacao: boolean
  possuiPerfisDeAcesso: boolean
  possuiAcessoPorLideranca: boolean
}

export type PermissaoUsuario = {
  nome: string
  modulo: string
  acao: string
  filtro?: string
}

export type FeatureFlag = {
  habilitada: boolean
  valor?: unknown
}

export type OrigemFuncionalidade = 'flagsmith' | 'legado'

export type DisponibilidadeAcesso = {
  modulos: Record<string, boolean>
  funcionalidades: Record<string, FeatureFlag>
  funcionalidadesLegadas: Record<string, FeatureFlag>
  origensFuncionalidades: Record<string, OrigemFuncionalidade>
}

export type ContextoAcesso = {
  statusUsuario: EstadoCarregamento
  statusDisponibilidade: EstadoCarregamento
  usuario: UsuarioAcesso | null
  empresa: EmpresaAcesso | null
  perfilAtivo: PerfilAcessoAtivo
  permissoes: PermissaoUsuario[]
  disponibilidade: DisponibilidadeAcesso
}

export type ContextoAcessoCarregado = {
  usuario: UsuarioAcesso
  empresa: EmpresaAcesso
  permissoes: PermissaoUsuario[]
}

export type SnapshotDisponibilidade = DisponibilidadeAcesso

export type FeatureFlagBruta = {
  enabled: boolean
  value?: unknown
}

export type SnapshotDisponibilidadeBruto = {
  modulos: Record<string, unknown>
  funcionalidades: Record<string, FeatureFlagBruta>
  funcionalidadesLegadas?: Record<string, unknown>
}

export type ConsultaPermissao =
  | { modulo: string, acao: string, filtros?: readonly string[] }
  | { any: readonly string[] }
  | { multiple: readonly string[] }
